export default "__VITE_ASSET__BRAghi2z__"